import { render, staticRenderFns } from "./ChatTemplates.vue?vue&type=template&id=8dec98e2&scoped=true&"
import script from "./ChatTemplates.vue?vue&type=script&lang=js&"
export * from "./ChatTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ChatTemplates.vue?vue&type=style&index=0&id=8dec98e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dec98e2",
  null
  
)

export default component.exports